import React, { Component } from 'react';
import firebase from '../firebase'
import {Link} from 'react-router-dom'

class Home extends Component {
  state={
    shops: []
  }
  componentDidMount() {
    // this.shopsRef = firebase.database().ref(`airtables/app5kutCkrmlRj1AS`)
    // this.shopsRef.on('value', (snapshot) => {
    //   if (!snapshot.val()) { return }
    //   let records = (snapshot.val().records || [])
    //     .map(r => Object.assign({}, r.fields, {id: r.id}) || {})
    //
    //   this.setState({shops: records})
    // })
  }
  componentWillUnmount() {
    this.shopsRef.off()
  }
  render() {
    let {name, id, photo, price, description} = this.props
    // console.log(this.props.className)
    return(
      <div style={{
        fontSize: '2em',
        margin: '1em',
        lineHeight: '1.5em'
      }}>

        <header>
          <div>A Food Apart presents —</div>
          <h1>Grido</h1>
          <ul>
            <li>Print Menus</li>
            <li>Control Your TV Screen with <a href="">Avocado Pi</a></li>
          </ul>
        </header>
        {this.state.shops.reverse().map((shop) => {
          return(
            <div><Link to={`/${shop.airtable_id}/default`}>{shop.name}</Link></div>
          )
        })}
      </div>
    )
  }
}
export default Home
